import { Outlet } from "react-router";
// import useMenuData from "src/common/hooks/useMenuData";
import { MainTemplate } from "../components/templates/MainTemplate";

export const MainRoutePage = () => {
  // useMenuData();

  return (
    <MainTemplate>
      <Outlet />
    </MainTemplate>
  );
};
